import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/Auth';
import { nextChallengeViewModel } from '../views/next_challenge/next.challenge.viewmodel';
import { ADD_MORE_TREEHOUSES, TREEHOUSE_ROUTE } from '../../constants/routes.constants';
import GuestRedirectVerification from './GuestRedirectVerification';
import { treehouseViewModel } from './treehouse.view.model';
import taletreeLogo from '../../assets/logo/logo-camp.svg';
import profilePicture from '../../assets/profile/default-profile-guardian.svg';
import EventEmitter from '../../utils/events';
import goldTick from '../../assets/icon/gold_tick.svg';
import silverTick from '../../assets/icon/silver_tick.svg';
import { Image } from 'react-bootstrap';
import SignupStep1 from '../views/onboarding/signup_popups/SignupStep1';

function SideBarTreehouses({setShowModal}) {
  const history = useHistory();
  const { dependent, guardian, fetchAPI } = useAuth();
  const [partners, setPartners] = useState([]);
  // const [showModal, setShowModal] = useState(false);

  const addMoreTreehouses = () => {
    if (dependent && !guardian) {
      history.push({
        pathname: ADD_MORE_TREEHOUSES,
        state: {
          treehouses: partners
        },
      })
    }
    else {
      setShowModal(true);
    }
  }

  const getPartnersList = () => {
    fetchAPI(nextChallengeViewModel.getPartners)
      .then((res) => {
        setPartners(res);
      })
      .catch((err) => { });
  };

  const getSubscribedTreehouses = () => {
    // treehouseViewModel.getSubscribedTreehouses().then((res) => {
      treehouseViewModel.getParmanentTreehouses().then((res) => {
      setPartners(res)
    }).catch((err) => { });
  }

  useEffect(() => {
    getSubscribedTreehouses()
    // if (dependent && !guardian) {
    //   // getPartnersList();
    //   getSubscribedTreehouses()
    //   // EventEmitter.subscribe('subscribe_treehouse', getSubscribedTreehouses)
    // }
    // return function () {
    //   EventEmitter.unsubscribe('subscribe_treehouse')
    // }
  }, []);

  const onTreehouseClick = (data) => {
      let id = data?.slug ? data?.slug : data?.id
      history.push({
        pathname: `${TREEHOUSE_ROUTE}/${id}`,
        state: {
          type: data?.slug ? 'slug' : 'id'
        }
      })
  }


  return (
    <>
      <div className='accordian-body'>
        <ul>
          {partners.map((item, key) => {
            return (
              <li key={key} onClick={() => onTreehouseClick(item)}>
                <a href="javascript:void(0);">
                  <span className='plus-ic'>
                    <img src={item.picture_url ? item.picture_url : profilePicture} alt='' />
                  </span>
                  {item.name_of_organisation}
                  {item.type_of_organisation === "profit" ?
                  <Image className="sidebar_treehouse_tick" src={goldTick} />
                  : <Image className="sidebar_treehouse_tick" src={silverTick} />
                  }
                </a>
              </li>
            )
          })}
        </ul>
      </div>
      {/* <div className='accordian-footer'
        onClick={addMoreTreehouses}>
        <span className='plus-ic'>+</span>
        <span className='hide-on-toggle hover-underline'>Add more Treehouses to your Interests</span>
      </div> */}

      {/* <GuestRedirectVerification showModal={showModal} setShowModal={setShowModal} /> */}
      {/* <SignupStep1 showModal={showModal} setShowModal={setShowModal} /> */}
    </>
  );
}

export default SideBarTreehouses;
